
export type ProfilerLogType = {
  enabled?: boolean;
  minimumDuration?: number;
};

export type ProfileNorthboundApisPropertiesType = {
  interfaces: Record<string, Record<string, any>>;
  log: ProfilerLogType;
  importmap: { imports: Record<string, string> };
  SystemJS: typeof System;
};

export type ProfileJWebPropertiesType = {
  JWeb: any;
  log: ProfilerLogType;
};

// TODO: Import the types from the library;
type ClientOSDevToolsType = {
  profiler: {
    addInvalidDataAlias: any;
    injectProfiler: any;
  };
  useCases: {
    profileNorthboundApis: (
      options: ProfileNorthboundApisPropertiesType
    ) => Promise<void>;
    profileJWeb: (options: ProfileJWebPropertiesType) => Promise<void>;
  };
};

export function shouldClientOSDevtoolsBeEnabled(): boolean {
  return !!(window as any)?.clientOSExternalToolsClientPromise;
}

let profileNorthboundApisCalled = false;
let profileJWebCalled = false;
export default async function getClientOSDevTools() {
  const clientOSDevtools: ClientOSDevToolsType | undefined =
    (window as any)?.clientOSExternalToolsClient?.default ||
    (await (window as any)?.clientOSExternalToolsClientPromise)?.default;

  console.log('ClientOS DevTools:', clientOSDevtools);

  const enabled = !!clientOSDevtools?.useCases?.profileNorthboundApis;

  return {
    isEnabled: async () => {
      if ((window as any)?.clientOSExternalToolsClientPromise && !enabled) {
        console.warn('Profiler is not enabled or not available.');
      }

      return enabled;
    },
    profileNorthboundApis: async (
      options: ProfileNorthboundApisPropertiesType
    ) => {
      if (!enabled || profileNorthboundApisCalled) return;
      profileNorthboundApisCalled = true;
      await clientOSDevtools?.useCases?.profileNorthboundApis?.(options);
    },
    profileJWeb: async (options: ProfileJWebPropertiesType) => {
      if (!enabled || profileJWebCalled) return;
      profileJWebCalled = true;
      await clientOSDevtools?.useCases?.profileJWeb?.(options);
    }
  };
}
